import { render } from "./Breadcrumbs.vue?vue&type=template&id=9dbae71e"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"
script.render = render

export default script